import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const DpinModal = ({ isOpen, onClose, onSuccess, itemType = 'item' }) => {
  const [dpin, setDpin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const token = Cookies.get('token');
      const response = await axios.post(
        'https://app-pune-ndt.cloud/api/dpin/verify',
        { dpin },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setDpin('');
        onSuccess(); // Call the success callback (will delete the item)
        onClose();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Failed to verify DPIN';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDpin('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Enter D-PIN</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ×
          </button>
        </div>

        <p className="text-gray-600 mb-6">
          Enter your 6-digit Delete PIN to confirm deletion of this {itemType}.
        </p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <input
              type="password"
              value={dpin}
              onChange={(e) => setDpin(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength="6"
              pattern="\d{6}"
              required
              className="w-full px-4 py-3 text-center text-2xl tracking-widest border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              placeholder="● ● ● ● ● ●"
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-2">
              Enter 6-digit PIN to authorize deletion
            </p>
          </div>

          <div className="flex space-x-4">
            <button
              type="submit"
              disabled={loading || dpin.length !== 6}
              className="flex-1 bg-red-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-red-700 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Verifying...' : 'Confirm Delete'}
            </button>
            <button
              type="button"
              onClick={handleClose}
              className="px-6 py-3 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition duration-300"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DpinModal;